export const accessToken = 'accessToken';
export const refreshToken = 'refreshToken';
export const F_TOKEN_STORE_KEY = 'F_TOKEN_STORE_KEY';
export const T_F_TOKEN_STORE_KEY = "T_F_TOKEN_STORE_KEY";